import { useEffect, useState } from 'react';

import { api, type CegLista, type CegSor } from '../api.ts';

/**
 * Cég megadása új partner felvételénél. (A megrendelő kérése, 2026-09-14)
 *
 * Gépelés közben felkínálja a rendszerben már meglévő cégeket — név,
 * adószám, székhely és telephelynév alapján is. Ha választanak, az új partner
 * a cég telephelye lesz. Ha nem, a beírt név marad a cégnév, és a program
 * az adószám alapján dönt: meglévő céghez teszi, vagy új céget nyit.
 */
export function CegValaszto({
  cegnev,
  onCegnev,
  ceg,
  onCeg,
  rogzitett = false,
}: {
  cegnev: string;
  onCegnev: (v: string) => void;
  ceg: CegSor | null;
  onCeg: (c: CegSor | null) => void;
  /** A Cégek képernyőről nyitva a cég adott, nem cserélhető. */
  rogzitett?: boolean;
}) {
  const [talalatok, setTalalatok] = useState<CegSor[]>([]);
  const [nyitva, setNyitva] = useState(false);

  useEffect(() => {
    const q = cegnev.trim();
    if (ceg || q.length < 2) {
      setTalalatok([]);
      return;
    }
    const idozito = setTimeout(async () => {
      try {
        const lista = await api.get<CegLista>(`/api/ceg?q=${encodeURIComponent(q)}`);
        setTalalatok(lista.sorok.slice(0, 8));
      } catch {
        setTalalatok([]);
      }
    }, 200);
    return () => clearTimeout(idozito);
  }, [cegnev, ceg]);

  if (ceg) {
    return (
      <div>
        <label>Cég</label>
        <div className="cegvalasztott">
          <b>{ceg.nev}</b>
          <small>
            {ceg.adoszam ?? 'adószám nélkül'} · {ceg.telephelyek} telephely
          </small>
          {!rogzitett && (
            <button className="btn sm" title="Másik cég" onClick={() => onCeg(null)}>
              ×
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <label>Cégnév</label>
      <input
        value={cegnev}
        autoComplete="off"
        placeholder="kezdd gépelni — a meglévő cégeket felkínálja"
        onChange={(e) => {
          onCegnev(e.target.value);
          setNyitva(true);
        }}
        onFocus={() => setNyitva(true)}
        onBlur={() => setTimeout(() => setNyitva(false), 150)}
      />
      {nyitva && talalatok.length > 0 && (
        <div className="cegjavaslat">
          {talalatok.map((c) => (
            <button
              key={c.id}
              // mousedown: még a mező elhagyása (blur) előtt fut le
              onMouseDown={(e) => {
                e.preventDefault();
                onCeg(c);
                setNyitva(false);
              }}
            >
              <b>{c.nev}</b>
              <small>
                {c.adoszam ?? 'adószám nélkül'} · {c.telephelyek} telephely
                {c.telephely_nevek.length > 0 && ` (${c.telephely_nevek.slice(0, 3).join(', ')})`}
              </small>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
